"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAllowedDomainSchema = exports.allowedDomainSchema = exports.updateFaqSchema = exports.createFaqSchema = exports.faqSchema = exports.updateQuickQuestionSchema = exports.createQuickQuestionSchema = exports.quickQuestionSchema = void 0;
const zod_1 = require("zod");
/**
 * 客服子资源 (Task 5)
 * - quick_questions  引导按钮 (访客打开 widget 时显示的快速提问)
 * - faqs            常见问题 (Q/A 列表)
 * - allowed_domains 嵌入白名单 (web/digital 公用)
 *
 * 字段定义见 spec §5.3
 */
// ---------------- Quick Questions ----------------
exports.quickQuestionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    csId: zod_1.z.string().uuid(),
    text: zod_1.z.string().min(1).max(255),
    sort: zod_1.z.number().int().min(0).default(0),
    i18n: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.createQuickQuestionSchema = exports.quickQuestionSchema.pick({
    text: true,
    sort: true,
    i18n: true,
});
exports.updateQuickQuestionSchema = exports.createQuickQuestionSchema.partial();
// ---------------- FAQs ----------------
exports.faqSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    csId: zod_1.z.string().uuid(),
    question: zod_1.z.string().min(1).max(500),
    answer: zod_1.z.string().min(1),
    sort: zod_1.z.number().int().min(0).default(0),
    i18n: zod_1.z
        .record(zod_1.z.string(), zod_1.z.object({ question: zod_1.z.string(), answer: zod_1.z.string() }))
        .nullable()
        .optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.createFaqSchema = exports.faqSchema.pick({
    question: true,
    answer: true,
    sort: true,
    i18n: true,
});
exports.updateFaqSchema = exports.createFaqSchema.partial();
// ---------------- Allowed Domains ----------------
// 简化正则: 允许字母数字、点、连字符、下划线、星号 (用于 *.example.com 子域通配)
exports.allowedDomainSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    csId: zod_1.z.string().uuid(),
    domain: zod_1.z
        .string()
        .min(1)
        .max(255)
        .regex(/^[\w*.-]+$/, '只允许字母、数字、点、连字符、下划线及通配符 *'),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.createAllowedDomainSchema = exports.allowedDomainSchema.pick({
    domain: true,
});
//# sourceMappingURL=cs-subresource.js.map